import type { ComponentType, ReactElement } from "react";

import type { SelectionModalProps, TriggerProps } from "../../types";

import { StyledTableColumnsSelectionContainer } from "./styles";

type Props = {
    className?: string;
    isOpen: boolean;
    onOpen: VoidFunction;
    onClose: VoidFunction;
    renderSelectionTrigger: ComponentType<TriggerProps>;
    renderSelectionModal?: ComponentType<SelectionModalProps>;
};

const TableColumnsSelection = ({
    className,
    isOpen,
    onOpen,
    onClose,
    renderSelectionTrigger: SelectionTrigger,
    renderSelectionModal: SelectionModal,
}: Props): ReactElement => {
    return (
        <StyledTableColumnsSelectionContainer className={className}>
            <SelectionTrigger onClick={onOpen} />

            {SelectionModal ? (
                <SelectionModal
                    isOpen={isOpen}
                    closeModal={onClose}
                />
            ) : null}
        </StyledTableColumnsSelectionContainer>
    );
};

export default TableColumnsSelection;
